export default __webpack_public_path__ + "static/media/household-keymap-12-1@2x.de0a9ff8.png";